<div class="mat-expansion-panel--blue">
    <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title>mis productos</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="panel-content px-small py-half">
            <div class="item item--main d-flex jc-space-between mb-half pb-base">
                <div>
                    <h3 class="mb-xsmall mt-none text-small">Plan M</h3>
                    <button class="button secondary rounded px-mid py-tiny text-xsmall" type="button">Renovar plan</button>
                </div>
                <div>
                    <p class="item__quantity mb-tiny">7<span class="available">Días Disponibles</span></p>
                    <p class="item__time text-xsmall">Vence: <time class="date-time text-small" datetime="05-18-2021">May / 18 / 2021</time></p>
                </div>
            </div>
            
            <div class="item d-flex jc-space-between px-tiny pb-xsmall mb-xsmall">
                <span class="item__icon material-icons">camera_alt</span>
                <p class="item__description">FOTOS 360 + TOUR VIRTUAL</p>
                <p class="item__quantity">3<span class="available">Disponibles</span></p>
            </div>
            <div class="item d-flex jc-space-between px-tiny pb-xsmall mb-xsmall">
                <span class="item__icon material-icons">3d_rotation</span>
                <p class="item__description">RECORRIDO 3D</p>
                <p class="item__quantity">1<span class="available">Disponible</span></p>
            </div>
            <div class="item d-flex jc-space-between px-tiny pb-xsmall mb-xsmall">
                <span class="item__icon material-icons">upgrade</span>
                <p class="item__description">INMUEBLES ASCENDIDOS</p>
                <p class="item__quantity">2<span class="available">Disponibles</span></p>
            </div>
            <div class="item d-flex jc-space-between px-tiny pb-xsmall mb-xsmall">
                <span class="item__icon material-icons">star_outline</span>
                <p class="item__description">INMUEBLES DESTACADOS</p>
                <p class="item__quantity">10<span class="available">Disponibles</span></p>
            </div>
            <div class="item d-flex jc-space-between px-tiny pb-xsmall mb-xsmall">
                <span class="item__icon material-icons">monetization_on</span>
                <p class="item__description">PRECIO  DE REFERENCIA</p>
                <p class="item__quantity">3<span class="available">Disponibles</span></p>
            </div>

        </div>
        <div class="panel-footer p-medium">
            <button class="button secondary rounded text-small mb-mid block" type="button">comprar productos</button>
            <button class="button bg-grayscale-gray-1 text-grayscale-base rounded text-small block" type="button">pagar plan</button>
        </div>
    </mat-expansion-panel>
</div>